import React, { useCallback } from 'react';
import { useResponsive } from '@sg/garnish';

import { LoadingAnimation } from '@order/components';
import { useTelemetry } from '@order/Telemetry';

import { useHomeContent, useLastOrderStatus } from '../../hooks';
import { HomeScreenContentV2SM } from './HomeScreenContentV2SM';
import { HomeScreenContentV2XS } from './HomeScreenContentV2XS';

export const HomeScreenContent = () => {
  const { currentBreakpoint } = useResponsive();

  // ─── Telemetry ───────────────────────────────────────────────────────

  const { track } = useTelemetry();

  const handleCtaPress = useCallback(() => {
    track('home.hero.cta_tapped');
  }, [track]);

  const handleBagPress = useCallback(() => {
    track('home.bag.cta_tapped');
  }, [track]);

  // ─── Data ────────────────────────────────────────────────────────────
  // Used from 'cache-only' in internal components.

  useLastOrderStatus('cache-and-network');

  // ─── Contentful ──────────────────────────────────────────────────────

  const { hasPlacedOrder, homeContent, isFetchingHomeContent } =
    useHomeContent();

  if (isFetchingHomeContent) {
    return <LoadingAnimation />;
  }

  // ─── Rendering ───────────────────────────────────────────────────────

  if (currentBreakpoint.isXS) {
    return (
      <HomeScreenContentV2XS
        homeContent={homeContent}
        bagPressed={handleBagPress}
        ctaPressed={handleCtaPress}
      />
    );
  }

  return (
    <HomeScreenContentV2SM
      homeContent={homeContent}
      hasPlacedOrder={hasPlacedOrder}
      ctaPressed={handleCtaPress}
    />
  );
};
